<template>
<div>
    <div class="loading_all_lot_list primary--text" v-if="loading_page === true">
        <v-progress-circular indeterminate size="80" color="primary"></v-progress-circular>
        <h2>Loading...</h2>
    </div>
    <div v-if="loading_page === false">
        <div class="mb-2">
            <h3>ดูรายการ เข้า-ออก ทั้งหมด</h3>
        </div>
        <v-card>
                <div class="pa-4 d-flex justify-center">
                    <div class="d-flex align-center justify-center" style="width: 100%;">
                        <div class="startdate_sale_statistic mr-2">
                        <v-menu ref="menu_start_date" v-model="menu_start_date" :close-on-content-click="false" :return-value.sync="start_date" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="start_date_be" label="วันที่ (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="start_date" :max="end_date" no-title scrollable locale="th" :events="dateStartEndBE('start_date')">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="searchDate('start_date')">
                                ตกลง
                            </v-btn>
                            <v-btn text color="primary" @click="menu_start_date = false">
                                ยกเลิก
                            </v-btn>
                            </v-date-picker>
                        </v-menu>
                        </div>
                    </div>
                </div>
                 <div class="col-12 d-flex justify-center">
                    <div class="mr-2" style="width: 400px;">
                        <v-select label="เเหล่งที่มา" :items="source_store_list" item-text="source_name" item-value="id" v-model="source_store_select" hide-details="auto" outlined ></v-select>
                    </div>
                    <div class="ml-2" style="width: 400px;">
                        <v-select  label="ประเภทสินค้า" :items="type_product_list" item-text="name" item-value="id" v-model="type_product_select" hide-details="auto" outlined ></v-select>
                    </div>
                </div>
                <div class="col-12 d-flex justify-center">
                    <v-btn color="#1094C7" class="white--text titlefont_poslist mx-2" type="submit" height="50" width="325" @click="exportPDFLot">
                        ดาวน์โหลดรายงาน ไฟล์ PDF
                    </v-btn>

                    <v-btn color="#28ab28" class="white--text titlefont_poslist mx-2" type="submit" height="50" width="325" @click="exportExcelLot">
                        ดาวน์โหลดรายงาน ไฟล์ Excel
                    </v-btn>
                </div>

            <v-card-title>
                <v-text-field v-model="bill_search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>

            <!-- <v-data-table :headers="headers" :items="data" :search="search"> -->
                <!-- {{ data }} -->
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">วันที่</th>
                                <th class="text-left">รายการ</th>
                                <th class="text-left">มูลค่ารวม </th>
                                <th class="text-left">ผู้บันทึก </th>
                                <th class="text-left">จัดการ </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dataDetail, key_history) in data" :key="key_history">
                                <td>{{dataDetail.date}} </td>
                                <td>{{dataDetail.name}}</td>
                                <td>{{dataDetail.price}}</td>
                                <td>{{dataDetail.user_name}}</td>
                                <td>
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
                                        </template>
                                        <v-list>
                                            <v-list-item class="cursor_all_lot_list" @click="lotDetail(dataDetail.id,dataDetail.type)">
                                                <v-list-item-title>ดูรายละเอียด</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item class="cursor_all_lot_list" @click="lotEdit(dataDetail.id,dataDetail.type)" v-if="$store.state.userProfile.permission_type == 1">
                                                <v-list-item-title>แก้ไข</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <div class="text-center mt-5 mb-5" v-if="page != null">
                    <v-pagination class="pb-3" v-model="page" :length="page_all" :total-visible="7"
                        color="#55c0e9"></v-pagination>
                </div>

        </v-card>
    </div>
    <NotFoundDialog v-model="dialogVisible" @retry="clearSearch"/>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
// import inoutstockall from '@/api/stock/stocklist/inoutstockall.js'
import stockmaterialnow from '@/api/stock/stocklist/stockmaterialnow.js'
import NotFoundDialog from "@/components/menuadmin/NotFoundDialog.vue";
import stocktype from '@/api/stock/stocksetting/stocktype.js'
export default {
    components: {NotFoundDialog},
    data() {
        const today = new Date().toISOString().split('T')[0];
        return {
            loading_page: true,
            search: '',
            headers: [{
                    text: 'วันที่',
                    align: 'start',
                    value: 'date',
                },
                {
                    text: 'รายการ',
                    value: 'name'
                },
                {
                    text: 'มูลค่ารวม',
                    value: 'price'
                },
                {
                    text: 'ผู้บันทึก',
                    value: 'user_name'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
            ],
            data: [],
            menu_start_date: false,
            menu_end_date: false,
            start_date_be: '',
            start_date: today,
            end_date_be: '',
            end_date: '',
            source_store_select:0,
            type_product_select:0,
            source_store_list:[{
                source_name:'ทั้งหมด',
                id:0
            }],
            type_product_list:[{
                name:'ทั้งหมด',
                id:0
            }],
            page: 1,
            page_all: 1,
            size:10,
            bill_search: '',
            page_null: null,
            dialogVisible:false
        }
    },
    methods: {
     
        async stockList() {
         
            // this.loading_page = true
            HTTP.get(`/lot/list_lot_in_out?page=${this.page}&size=${this.size}&search=${this.bill_search}`, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.list
                    if (this.bill_search != '') {
                        this.page = 1
                        this.page_all = 1
                        this.size = 50
                    }else{
                        this.loading_page = true
                        this.page = response.data.current_page ? parseFloat(response.data.current_page) : null
                        this.page_all = response.data.pages ? response.data.pages : 1
                        this.size = 10
                        this.loading_page = false
                    }
                   
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async lotDetail(id, name) {
            const idPage = {
                id: id
            }
            if (name === 1) {
                this.$store.commit('lotDetailInPage', idPage)
                this.$router.push('/lotdetailin')
            }
            if (name === 0) {
                this.$store.commit('lotDetailOutPage', idPage)
                this.$router.push('/lotdetailout')
            }

        },
        async lotEdit(id, name) {
            const idPage = {
                id: id
            }
            if (name === 1) {
                this.$store.commit('lotDetailInEditPage', idPage)
                this.$router.push('/lotdetailinedit')
            }
            if (name === 0) {
                this.$store.commit('lotDetailOutEditPage', idPage)
                this.$router.push('/lotdetailoutedit')
            }

        },
        async searchDate(type) {
            if (type == 'start_date') {
                this.$refs.menu_start_date.save(this.start_date)
                let date_arr = this.start_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.start_date_be = `${date_arr[2]}/${month}/${year}`
                this.menu_start_date = false
            }
            if (type == 'end_date') {
                this.$refs.menu_end_date.save(this.end_date)
                let date_arr = this.end_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.end_date_be = `${date_arr[2]}/${month}/${year}`
                this.menu_end_date = false
            }
        },
        dateStartEndBE(type) {
            if (type == 'start_date') {
                if (this.start_date == '') {
                this.start_date_be = ''
                }
                if (this.start_date) {
                let date_arr = this.start_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.start_date_be = `${date_arr[2]}/${month}/${year}`
                }
            }
            if (type == 'end_date') {
                if (this.end_date == '') {
                this.end_date_be = ''
                }
                if (this.end_date) {
                let date_arr = this.end_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.end_date_be = `${date_arr[2]}/${month}/${year}`
                }
            }
        },
        exportExcelLot(){
            let sourceId = this.source_store_list.find((detail) => {
                return detail.id == this.source_store_select
            })
            let typeId = this.type_product_list.find((detail) => {
                return detail.id == this.type_product_select
            })
                HTTP.post('/stock/export_excel_material_lot', {source_store:sourceId,type_product:typeId,date:this.start_date},{
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        },
                        responseType: 'blob'
                    })
                    .then((response) => {
                        if (response.status == 200) {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const downloadLink = document.createElement('a');
                            downloadLink.href = url;
                            downloadLink.setAttribute('download', 'material_lot.xlsx');
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            document.body.removeChild(downloadLink);
                        }

                    })
                    .catch((error) => {
                        if(error.response.status === 404){
                            this.dialogVisible = true;
                        }
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
        },
        exportPDFLot(){
            let sourceId = this.source_store_list.find((detail) => {
                return detail.id == this.source_store_select
            })
            let typeId = this.type_product_list.find((detail) => {
                return detail.id == this.type_product_select
            })
                HTTP.post('/stock/export_pdf_material_lot', {source_store:sourceId,type_product:typeId,date:this.start_date},{
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        },
                        responseType: 'blob'
                    })
                    .then((response) => {
                        if (response.status == 200) {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const downloadLink = document.createElement('a');
                            downloadLink.href = url;
                            downloadLink.setAttribute('download', 'material_lot.pdf');
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            document.body.removeChild(downloadLink);
                        }

                    })
                    .catch((error) => {
                        if(error.response.status === 404){
                            this.dialogVisible = true;
                        }
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
        },
        async stockMaterialList() {
            this.loading_page = true
            this.source_page_list = []
            // this.data = []

            await stockmaterialnow.materialList().then((response) => {
                if (response.data.successful === true) {
                    response.data.sources.forEach((detail) => {
                        this.source_store_list.push({
                            id: detail.id,
                            source_name: detail.source_name,
                        })
                    })
                    // this.data = response.data.sources
                    // this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            await stocktype.typeList().then((response) => {
                if (response.data.successful === true) {
                    this.type_list = response.data.material_type;
                    this.type_list.forEach(el=>{
                        this.type_product_list.push({
                            id:el.id,
                            name:el.name
                        })
                    })
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        clearSearch(is_retry){            
            if(is_retry){
                this.dialogVisible = false
                this.source_store_select = 0
                this.type_product_select = 0
                this.date = new Date().toISOString().split('T')[0]
                this.stockMaterialList()
            }
        }
    },
    mounted() {
        this.stockList()
        this.stockMaterialList()

    },
    watch: {
        page() {
            this.stockList()
        },
        bill_search() {
            this.stockList()
        }
    }
}
</script>

<style scoped>
.cursor_all_lot_list {
    cursor: pointer;
}

.loading_all_lot_list {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 100;
    background: rgba(0, 0, 0, 0.8);
}
</style>
